import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  remoteUpgradeTime(value, deviceSerial) {
    buryPoint.timing({
      name: '远程升级-升级平均耗时',
      value,
      eventCategory: '远程升级',
      eventLabel: `设备序列号：${ deviceSerial}`
    });
  },
  singleDeviceUpgrade() {
    buryPoint.event({
      action: '单个设备升级-使用功能',
      eventCategory: '单个设备升级',
      eventLabel: '健康监测-所有站点'
    });
  },
  singleDeviceUpgradeType(flag) {
    const op = {
      1: '编码设备',
      2: '报警主机',
      3: '对讲',
      4: '门禁',
      5: '门铃',
      6: '云存储盒子'
    };
    buryPoint.event({
      action: '单个设备升级-设备类型',
      eventCategory: '单个设备升级',
      eventLabel: op[flag]
    });
  },
  singleDeviceUpgradeResult(flag) {
    const op = {
      0: '升级成功',
      1: '升级失败'
    };
    buryPoint.event({
      action: '单个设备升级-升级结果',
      eventCategory: '单个设备升级',
      eventLabel: op[flag]
    });
  },
  singleDeviceUpgradeTime(value, eventLabel) {
    buryPoint.timing({
      name: '单个固件升级-升级时间',
      value,
      eventCategory: '单个固件升级',
      eventLabel
    });
  },
  batchDeviceUpgrade(where) {
    const op = {
      0: '站点模块-站点详情',
      1: '健康监测-所有站点'
    };
    buryPoint.event({
      action: '批量固件升级-使用功能',
      eventCategory: '批量固件升级',
      eventLabel: op[where]
    });
  },
  batchDeviceUpgradeCount(num) {
    buryPoint.event({
      action: '批量固件升级-升级数量',
      eventCategory: '批量固件升级',
      eventLabel: num
    });
  },
  batchDeviceUpgradeSuccessCount(num) {
    buryPoint.event({
      action: '批量固件升级-升级成功数量',
      eventCategory: '批量固件升级',
      eventLabel: num
    });
  },
  batchDeviceUpgradeTime(value, eventLabel) {
    buryPoint.timing({
      name: '批量固件升级-升级时间',
      value,
      eventCategory: '批量固件升级',
      eventLabel
    });
  },
  remoteConfig(where) {
    const op = {
      0: '站点模块-站点详情-非局域网',
      1: '健康监测-所有站点',
      2: '健康监测-站点详情',
      3: '站点模块-站点详情-局域网'
    };
    buryPoint.event({
      action: '远程设备配置-使用功能',
      eventCategory: '远程设备配置',
      eventLabel: op[where]
    });
  },
  preview(where) {
    const op = {
      0: '站点模块-站点详情',
      1: '健康监测-所有站点',
      2: '健康监测-站点详情'
    };
    buryPoint.event({
      action: '远程预览-使用功能',
      eventCategory: '远程预览',
      eventLabel: op[where]
    });
  },
  playback(where) {
    const op = {
      0: '站点模块-站点详情',
      1: '健康监测-所有站点',
      2: '健康监测-站点详情'
    };
    buryPoint.event({
      action: '远程回放-进入方式',
      eventCategory: '远程回放',
      eventLabel: op[where]
    });
  },
  remoteConfigLoadTime(value, eventLabel) {
    buryPoint.timing({
      name: '远程设备配置-加载时长',
      value,
      eventCategory: '远程设备配置',
      eventLabel
    });
  },
  remoteConfigPageLoadTime(value, eventLabel) {
    buryPoint.timing({
      name: '远程设备配置-页面加载时长',
      value,
      eventCategory: '远程设备配置',
      eventLabel
    });
  },
  remoteConfigFirstUseTime(value, eventLabel) {
    buryPoint.timing({
      name: '远程设备配置-首次使用时长',
      value,
      eventCategory: '远程设备配置',
      eventLabel
    });
  },
  previewLoadTime(value, eventLabel) {
    buryPoint.timing({
      name: '远程预览-出流耗时',
      value,
      eventCategory: '远程预览',
      eventLabel
    });
  },
  previewLoadTimeException(value, eventLabel) {
    buryPoint.timing({
      name: '远程预览-出流耗时异常',
      value,
      eventCategory: '远程预览',
      eventLabel
    });
  },
  playbackLoadTime(value, eventLabel) {
    buryPoint.timing({
      name: '远程回放-出流耗时',
      eventCategory: '远程回放',
      value,
      eventLabel
    });
  },
  playbackPlayTime(value, eventLabel) {
    buryPoint.timing({
      name: '远程回放-出流耗时(不包含录像搜索)',
      eventCategory: '远程回放',
      value,
      eventLabel
    });
  },
  onlyViewAdnormalDevice(where, operation) {
    const op = {
      0: '健康监测-所有站点',
      1: '健康监测-站点详情'
    };
    const status = {
      0: '去除勾选',
      1: '勾选'
    };
    buryPoint.event({
      action: '仅查看异常设备-使用功能',
      eventCategory: op[where],
      eventLabel: status[operation]
    });
  },
  onlyViewHasPermissionDevice(where, operation) {
    const op = {
      0: '健康监测-所有站点',
      1: '健康监测-站点详情'
    };
    const status = {
      0: '去除勾选',
      1: '勾选'
    };
    buryPoint.event({
      action: '仅查看有权限设备-使用功能',
      eventCategory: op[where],
      eventLabel: status[operation]
    });
  },
  deviceListInspect() {
    buryPoint.event({
      action: '设备列表刷新-使用功能',
      eventCategory: '设备列表刷新',
      eventLabel: '健康监测-所有站点'
    });
  },
  deviceListUnfold() {
    buryPoint.event({
      action: '设备列表展开-使用功能',
      eventCategory: '设备列表展开',
      eventLabel: '健康监测-所有站点'
    });
  },
  deviceListViewSiteInfo() {
    buryPoint.event({
      action: '查看站点详情-使用功能',
      eventCategory: '查看站点详情',
      eventLabel: '健康监测-所有站点'
    });
  },
  viewSiteOwner() {
    buryPoint.event({
      action: '查看站点所有者-使用功能',
      eventCategory: '查看站点所有者',
      eventLabel: '健康监测-站点详情'
    });
  },
  viewSiteManagerInfo() {
    buryPoint.event({
      action: '查看站点负责人-使用功能',
      eventCategory: '查看站点负责人',
      eventLabel: '健康监测-站点详情'
    });
  },
  singleSiteInspect() {
    buryPoint.event({
      action: '站点巡检/站点刷新-使用功能',
      eventCategory: '站点巡检/站点刷新',
      eventLabel: '健康监测-站点详情'
    });
  },
  singleDeviceCardInspect() {
    buryPoint.event({
      action: '单设备刷新-使用功能',
      eventCategory: '单设备刷新',
      eventLabel: '健康监测-站点详情'
    });
  },
  DeviceRemoteConfigTypeInspect(index) {
    const type = {
      0: 'IPC',
      1: 'DVR/NVR',
      2: '可视对讲',
      3: '门禁',
      4: '报警主机',
      5: '门铃',
      6: '云存储盒子',
      7: '热成像'
    };

    buryPoint.event({
      action: '远程设备配置-设备类型',
      eventCategory: '远程设备配置',
      eventLabel: type[index]
    });
  },
  clickClearCache() {
    buryPoint.event({
      action: '清除远程缓存-使用功能',
      eventCategory: '清除远程缓存'
    });
  },
  doorBellChimeConfig(index) {
    const type = {
      0: '机械chime',
      1: '电子chime',
      2: '不安装chime'
    };

    buryPoint.event({
      action: '门铃机chime配置-使用功能',
      eventCategory: '门铃机chime配置',
      eventLabel: type[index]
    });
  },
  doorBellChimeConfigSuccess(index) {
    const type = {
      0: '机械chime',
      1: '电子chime',
      2: '不安装chime'
    };

    buryPoint.event({
      action: '门铃机chime配置-配置成功',
      eventCategory: '门铃机chime配置',
      eventLabel: type[index]
    });
  },
  remoteConfigOperatingTime(time, eventLabel) {
    buryPoint.timing({
      name: '远程设备配置-使用时长',
      value: time,
      eventCategory: '远程设备配置',
      eventLabel
    });
  },
  remoteConfigCloseTime(time, eventLabel) {
    buryPoint.timing({
      name: '远程设备配置-提前关闭等待时长',
      value: time,
      eventCategory: '远程设备配置',
      eventLabel
    });
  },
  previewChannelCount(num) {
    buryPoint.event({
      action: '远程预览-预览路数',
      eventCategory: '远程预览',
      eventLabel: num
    });
  },
  previewChannelResult(index) {
    const opt = {
      0: '无预览权限',
      1: '预览失败'
    };

    buryPoint.event({
      action: '远程预览-预览结果',
      eventCategory: '远程预览',
      eventLabel: opt[index]
    });
  },
  previewOperatingTime(time, userType) {
    const userList = ['安装商', '系统集成商', '接警中心', '终端用户', 'IT人员', '其他', '分销商'];
    buryPoint.timing({
      name: '远程预览-使用时长',
      value: time,
      eventCategory: '远程预览',
      eventLabel: userList[userType]
    });
  },
  previewReadyTime(time, eventLabel) {
    buryPoint.timing({
      name: '远程预览-准备时长',
      value: time,
      eventCategory: '远程预览',
      eventLabel
    });
  },
  enterHealthCheck(where) {
    const op = {
      1: '左侧导航面板',
      2: 'Home页-设备概览',
      3: 'Home页-常用操作'
    };
    buryPoint.event({
      action: '浏览健康检测模块-入口位置',
      eventCategory: '浏览健康检测模块',
      eventLabel: op[where]
    });
  },
  siteSearchInHealthCheck() {
    buryPoint.event({
      action: '站点检索-使用功能',
      eventCategory: '站点检索',
      eventLabel: '健康监测-站点搜索'
    });
  },
  deviceHealthDiagnosis() {
    buryPoint.event({
      action: '健康诊断-使用功能',
      eventCategory: '健康诊断',
      eventLabel: '健康监测-健康诊断'
    });
  },
  deviceHealthDiagnosisMinsize () {
    buryPoint.event({
      action: '健康诊断-收起诊断页',
      eventCategory: '健康诊断',
      eventLabel: '健康监测-健康诊断'
    });
  },
  deviceHealthDiagnosisTime (value, eventLabel) {
    buryPoint.timing({
      name: '健康诊断-诊断时长',
      value,
      eventCategory: '健康诊断',
      eventLabel
    });
  },
  exportSingleDeviceReport () {
    buryPoint.event({
      action: '查看单个设备诊断报告-使用功能',
      eventCategory: '查看单个设备诊断报告',
      eventLabel: '健康监测-健康诊断'
    });
  },
  exportAllDeviceReport () {
    buryPoint.event({
      action: '导出诊断报告-使用功能',
      eventCategory: '导出诊断报告',
      eventLabel: '健康监测-健康诊断'
    });
  },
  exceptionTiming(label) {
    buryPoint.event({
      action: '异常埋点',
      eventCategory: '健康监测',
      eventLabel: label
    });
  },
  listView(index) {
    const type = {
      0: '查看未知设备状态',
      1: '查看编码设备状态',
      2: '查看报警主机状态',
      3: '查看可视对讲状态',
      4: '查看门禁设备状态',
      5: '查看门铃机状态',
      6: '查看云存储盒子状态',
      8: '查看交换机状态'
    };

    buryPoint.event({
      action: `${type[index] }-查看信息`,
      eventCategory: type[index],
      eventLabel: type[index]
    });
  },
  amplifyPreview() {
    buryPoint.event({
      action: '远程预览-双击放大',
      eventCategory: '远程预览'
    });
  },
  previewTotalMinutes(time, label) {
    buryPoint.timing({
      name: '远程预览-预览总时长',
      eventCategory: '远程预览',
      eventLabel: label,
      value: time
    });
  },
  PreviewCapture() {
    buryPoint.event({
      action: '预览操作-抓图-使用功能',
      eventCategory: '预览操作-抓图'
    });
  },
  PreviewRecord() {
    buryPoint.event({
      action: '预览操作-录像-使用功能',
      eventCategory: '预览操作-录像'
    });
  },
  PreviewDigitalZoom() {
    buryPoint.event({
      action: '预览操作-电子放大-使用功能',
      eventCategory: '预览操作-电子放大'
    });
  },
  PreviewEnableAudio() {
    buryPoint.event({
      action: '预览操作-语音对讲-使用功能',
      eventCategory: '预览操作-语音对讲'
    });
  },
  PreviewOpenQualitySwitch() {
    buryPoint.event({
      action: '预览操作-画质切换-使用功能',
      eventCategory: '预览操作-画质切换'
    });
  },
  PreviewQualitySwitch(index) {
    const quality = {
      0: 'high',
      1: 'standard',
      2: 'fluent'
    };
    buryPoint.event({
      action: '预览操作-画质切换-画质选项',
      eventCategory: '预览操作-画质切换',
      eventLabel: quality[index]
    });
  },
  PreviewOpenPTZ() {
    buryPoint.event({
      action: '预览操作-PTZ-使用功能',
      eventCategory: '预览操作-PTZ'
    });
  },
  playbackUsageCount() {
    buryPoint.event({
      action: '远程回放-使用功能',
      eventCategory: '远程回放'
    });
  },
  playbackSplitWindows(num) {
    buryPoint.event({
      action: '远程回放-窗口分割数',
      eventCategory: '远程回放',
      eventLabel: num
    });
  },
  playbackChannelCount(num) {
    buryPoint.event({
      action: '远程回放-选择通道',
      eventCategory: '远程回放',
      eventLabel: num
    });
  },
  playbackResult(index, reason) {
    const opt = {
      0: '回放成功',
      1: '无回放权限',
      2: '回放失败'
    };

    buryPoint.event({
      action: '远程回放-回放结果',
      eventCategory: '远程回放',
      eventLabel: reason ? `${opt[index] } ${ reason}` : opt[index]
    });
  },
  playbackOperatingTime(time, userType) {
    const userList = ['安装商', '系统集成商', '接警中心', '终端用户', 'IT人员', '其他', '分销商'];
    buryPoint.timing({
      name: '远程回放-使用时长',
      eventCategory: '远程回放',
      eventLabel: userList[userType],
      value: time
    });
  },
  videoDownload() {
    buryPoint.event({
      action: '录像下载-使用功能',
      eventCategory: '录像下载'
    });
  },
  videoDownloadResult(index, reason) {
    const opt = {
      0: '下载成功',
      1: '下载失败'
    };

    buryPoint.event({
      action: '录像下载-下载结果',
      eventCategory: '录像下载',
      eventLabel: reason ? `${opt[index] } ${ reason}` : opt[index]
    });
  },
  viewTopoInfoCount() {
    buryPoint.event({
      action: '查看拓扑图-查看信息',
      eventCategory: '查看拓扑图'
    });
  },
  enterTopoMethod(type) {
    const opt = {
      0: '站点详情-未加入运维包',
      1: '站点详情-已加入运维包',
      2: '健康监测-all site',
      3: '健康监测-站点详情'
    };
    buryPoint.event({
      action: '查看拓扑图-入口位置',
      eventCategory: '查看拓扑图',
      eventLabel: opt[type]
    });
  },
  toolsClickCount(type) {
    const opt = {
      0: '放大/缩小',
      1: '适应屏幕显示',
      2: '显示/隐藏鹰眼',
      3: '全屏显示/退出全屏'
    };
    buryPoint.event({
      action: '查看拓扑图-按钮点击',
      eventCategory: '查看拓扑图',
      eventLabel: opt[type]
    });
  },
  viewDeviceDetailCount() {
    buryPoint.event({
      action: '设备详情-查看信息',
      eventCategory: '设备详情'
    });
  },
  viewDeviceDetailMethod(type) {
    const opt = {
      0: '站点详情-设备卡片',
      1: '设备拓扑图',
      2: '健康监测-站点详情-设备卡片'
    };
    buryPoint.event({
      action: '设备详情-入口位置',
      eventCategory: '设备详情',
      eventLabel: opt[type]
    });
  },
  changeSwitchRoot() {
    buryPoint.event({
      action: '拓扑图选择根节点-使用功能',
      eventCategory: '拓扑图选择根节点'
    });
  },
  TopologicalMapRetrieval() {
    buryPoint.event({
      action: '拓扑图检索-使用功能',
      eventCategory: '拓扑图检索'
    });
  },
  RebootSwitchCount() {
    buryPoint.event({
      action: '重启交换机-使用功能',
      eventCategory: '重启交换机'
    });
  },
  RebootSwitchPosition(type) {
    const opt = {
      1: '站点详情-未加入运维包',
      2: '站点详情-已加入运维包',
      3: '健康监测-all site列表',
      4: '健康监测-站点详情',
      5: '设备详情侧滑栏'
    };
    if (opt[type]) {
      buryPoint.event({
        action: '重启交换机-入口位置',
        eventCategory: '重启交换机',
        eventLabel: opt[type]
      });
    }
  },
  RebootSwitchResult(type, reason) {
    const opt = {
      1: '重启成功',
      2: '重启失败,'
    };
    let label = opt[type];
    if (type === 2) {
      label += reason;
    }
    buryPoint.event({
      action: '重启交换机-重启结果',
      eventCategory: '重启交换机',
      eventLabel: label
    });
  },
  autoReportExampleView() {
    buryPoint.event({
      action: '报表示例-查看信息',
      eventCategory: '报表示例'
    });
  },
  autoReportSearch() {
    buryPoint.event({
      action: '报表搜索站点-使用功能',
      eventCategory: '报表搜索站点'
    });
  },
  autoReportEnable(flag) {
    const op = {
      1: '启用',
      2: '关闭'
    };
    buryPoint.event({
      action: '全部站点报表启用/关闭-使用功能',
      eventCategory: '全部站点报表启用/关闭',
      eventLabel: op[flag]
    });
  },
  autoReportSiteEnable(flag) {
    const op = {
      1: '启用',
      2: '关闭'
    };
    buryPoint.event({
      action: '站点报表启用/关闭-使用功能',
      eventCategory: '站点报表启用/关闭',
      eventLabel: op[flag]
    });
  },
  autoReportClickBatchSetting() {
    buryPoint.event({
      action: '批量配置报表-进入批量配置模式',
      eventCategory: '批量配置报表'
    });
  },
  autoReportSaveBatchSetting() {
    buryPoint.event({
      action: '批量配置报表-完成配置',
      eventCategory: '批量配置报表'
    });
  },
  autoReportSingleSiteEdit() {
    buryPoint.event({
      action: '按站点配置报表-进入站点编辑模式',
      eventCategory: '按站点配置报表'
    });
  },
  autoReportSingleSiteSave() {
    buryPoint.event({
      action: '按站点配置报表-完成配置',
      eventCategory: '按站点配置报表'
    });
  }

};
